import React, { Component } from "react";
import { NavLink } from 'react-router-dom';
import { Autocomplete } from "@material-ui/lab";
import { Grid, Button, Snackbar,TextField } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import Sidebar from "../../../components/Sidebar_Com";
import Spinner from "../../../components/Loading_Com";
import Table from '../../../components/Table_Com';
import Modal from "../../../components/Modal_Com";
import logo from "../../../assets/img/logo.png";
import { getTransitions } from "../../../logic/APIHandler";
import "../../../styles/ManualTable_Styles.css";
import "../../../styles/Pagination_Styles.css";
import moment from "moment";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class TransitionPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            // excelData: [],
            // filenameRange: "",
            selectedId: "",
            openJWT: false,
            openModal: false,
            openDecline: false,
            isLoading: false,
            isSidebarOpen: 'slide-out',
            openErrorAlert: false,
            errorText: "",
            currBranch:
                localStorage.getItem("level") !== "1"? null
                : localStorage.getItem("currBranch")? JSON.parse(localStorage.getItem("currBranch"))
                : null,
        }
        // this.excelRef = React.createRef();
        this.windowWidth = window.innerWidth;
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.handleClose = this.handleClose.bind(this);
        // this.downloadExcel = this.downloadExcel.bind(this);
        this.handleFilterBranch = this.handleFilterBranch.bind(this);
    }

    columns = [
        {
            title: "Tanggal",
            field: "created_at",
            tooltip: "Tanggal transisi produk",
            render: rowData =>
                <p>{moment(rowData.created_at).format("DD MMMM YYYY HH:mm:ss")}</p>
        },
        {
            title: "No. Invoice", 
            field: "invoice",
            tooltip: "Nomor invoice transisi",
            render: rowData => rowData.invoice?
                <p>{rowData.invoice}</p> : <p>-</p>
        },
    ]
    
    actions = [
        {
            icon: () => <FindInPageIcon />,
            tooltip: "Lihat Detail Transisi",
            onClick: (event, rowData) => {
                this.props.history.push({
                    pathname: "transisi/" + rowData._id,
                })
            }
        },
    ]

    // Toggle sidebar menu in responsive
    toggleSidebar() {
        if ( this.state.isSidebarOpen === 'slide-out' ) {
            this.setState({
                isSidebarOpen: 'slide-in',
            });
        }
        else {
            this.setState({
                isSidebarOpen: 'slide-out',
            });
        }
    }

    // Close toast or modal
    handleClose() {
        this.setState({
            openModal: false,
            openDecline: false,
            openErrorAlert: false,
        });
    };
    
    async handleFilterBranch(branch) {
        this.setState({
            isLoading: true,
            currBranch: branch,
        });
        localStorage.removeItem("tablePage");
        localStorage.removeItem("saved-so");
        localStorage.removeItem("saved-so-store");
        localStorage.setItem("currBranch", JSON.stringify(branch));
        let resp = await getTransitions(branch.value);
        if ( resp[0] && resp[0].status === 200 ) {
            this.setState({
                data: resp[0].data,
            })
        }
        else if ( resp[0] && resp[0].status === 204 ) {
            this.setState({
                data: [],
            })
        }
        else {
            console.log(resp);
            this.setState({
                data: [],
                errorText: "Gagal mem-filter berdasarkan cabang.",
                openErrorAlert: true,
            })
        }
        this.setState({ isLoading: false });
    }

    // Get initial data
    async getData() {
        this.setState({ isLoading: true });
        let resp = "";
        if ( localStorage.getItem("level") === "1" ) {
            if ( localStorage.getItem("currBranch") ) {
                const branch = JSON.parse(localStorage.getItem("currBranch"));
                resp = await getTransitions(branch.value);
            }
        }
        else {
            resp = await getTransitions();
        }
        if ( resp[0] && resp[0].status === 200 ) {
            this.setState({
                data: resp[0].data,
                isLoading: false,
            })
        }
        else if ( resp[1] && resp[1].status === 401) {
            this.setState({
                openJWT: true,
                isLoading: false,
            });
        }
        else {
            this.setState({
                isLoading: false,
            })
        }
    }

    componentDidMount() {
        if ( localStorage.getItem("path") !== this.props.location.pathname ) {
            localStorage.removeItem("path");
            localStorage.removeItem("search");
            localStorage.removeItem("tablePage");
        }
        this.getData();
    }

    render() {
        return (
            <div className="content">
                <Sidebar
                    sidebarState={(this.windowWidth < 768)? this.state.isSidebarOpen : ""}
                    level={localStorage.getItem("level")}
                />

                <Modal
                    open={this.state.openModal}
                    onClose={this.handleClose}
                    onClickCancel={this.handleClose}
                    modalType="approve-trx"
                    id={this.state.selectedId}
                    modalTitle="Lengkapi Data Transaksi"
                    submitText="Submit"
                    cancelText="Cancel"
                />
                <Modal
                    open={this.state.openDecline}
                    onClose={this.handleClose}
                    onClickCancel={this.handleClose}
                    modalType="decline-trx"
                    id={this.state.selectedId}
                    color="secondary"
                    modalTitle="Tolak transaksi pembelian?"
                    dataName={this.state.productName}
                    submitText="Tolak"
                    cancelText="Cancel"
                />
                <Modal
                    open={this.state.openJWT}
                    modalType="handle-jwt"
                    modalTitle="Token Anda Sudah Expire"
                />

                <Grid container className="responsive-header">
                    <Grid item xs={6}>
                        <img src={logo} alt="logo" className="header-logo" />
                    </Grid>
                    <Grid item xs={6} className="menu-icon-btn">
                        <Button variant="outlined" onClick={this.toggleSidebar}>
                            {this.state.isSidebarOpen === 'slide-out'? <MenuIcon /> : <CloseIcon />}
                        </Button>
                    </Grid>
                </Grid>

                <Grid container className="grid-container" style={{ position: "relative" }}>
                    {localStorage.getItem("level") === "1"?
                        <Grid item xs={12} className="add-margin-bottom">
                            <Autocomplete
                                className="full-width tf-label"
                                onChange={(_, value) => this.handleFilterBranch(value)}
                                options={localStorage.getItem("branch")?
                                    JSON.parse(localStorage.getItem("branch")) : []
                                }
                                getOptionLabel={(option) => option.label}
                                disableClearable={true}
                                value={this.state.currBranch}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Cabang"
                                        placeholder="Pilih"
                                        variant="outlined"
                                        InputLabelProps={{
                                        shrink: true,
                                        }}
                                    />}
                            />
                        </Grid> : <></>
                    }

                    <Snackbar open={this.state.openErrorAlert} autoHideDuration={3000} onClose={this.handleClose}>
                        <Alert severity="error">
                            {this.state.errorText}
                        </Alert>
                    </Snackbar>

                    { this.state.isLoading ? ( <Spinner /> ) : <>
                        <Grid item xs={12} className="material-table add-margin-top">
                            <Table
                                tableTitle="Tabel Transisi"
                                tableColumns={this.columns}
                                data={this.state.data}
                                tableActions={this.actions}
                            />
                        </Grid>
                        {localStorage.getItem("level") !== "1"?
                            <Grid item xs={12} className="table-footer">
                                <NavLink to="/transisi-form" style={{ textDecoration: "none" }}>
                                    <Button variant="contained" className="add-btn-table">
                                        Transisikan Stok
                                    </Button>
                                </NavLink>
                            </Grid> : <></>
                        }
                    </> }
                </Grid>
            </div>
        );
    }
}

export default TransitionPage;